import { CommonModule } from '@angular/common';
import { Component, Input, SimpleChanges } from '@angular/core';
import { RESPONSE_CODE } from 'src/app/helper/class/app-constant';
import { pageInfo } from 'src/app/helper/interface/menu-interface';
import { ResponseData } from 'src/app/helper/interface/response';
import { FeatureModalModule } from 'src/app/shared/feature-modal/feature-modal.module';
import { ImageUploadModule } from 'src/app/shared/shared.module';
import { StudentApiService } from '../../service/student-api.service';
import { calculateAge } from 'src/app/helper/class/utilityHelper';

@Component({
  selector: 'student-basic-info',
  standalone: true,
  imports: [CommonModule, FeatureModalModule, ImageUploadModule],
  templateUrl: './student-basic-info.component.html',
  styleUrl: './student-basic-info.component.scss'
})
export class StudentBasicInfoComponent {

  @Input() StudentSourceData: any = null
  pageInfo: pageInfo = { title: 'Student Info' }
  isModal: boolean = false

  constructor(private studentApi: StudentApiService) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['StudentSourceData'] && this.StudentSourceData) {
      this.getAge();
    }
  }

  setInput(studentId) {
    if (studentId) {
      this.getStudentInfo(studentId)
      this.isModal = true
    }
  }

  getStudentInfo(studentId) {
    this.studentApi.getDetails(studentId).then((res: ResponseData) => {
      if (res.statusCode == RESPONSE_CODE.SUCCESS) {
        this.StudentSourceData = res.result
        this.getAge()
        if (this.StudentSourceData?.optional_fees_typeName) {
          this.StudentSourceData.optional_fees_typeName = this.StudentSourceData.optional_fees_typeName.join(',')
        }
      }
    })
  }

  getAge() {
    if (this.StudentSourceData) {
      this.StudentSourceData.age = calculateAge(this.StudentSourceData.dob)
    }
  }
}
